import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=12d37042&scoped=true"
import script from "./tables.vue?vue&type=script&lang=js"
export * from "./tables.vue?vue&type=script&lang=js"
import style0 from "./tables.vue?vue&type=style&index=0&id=12d37042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d37042",
  null
  
)

export default component.exports